import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class PayorService {
  private payorChangeSubject = new BehaviorSubject<boolean>(false);

  get payorChange$(): Observable<boolean> {
    return this.payorChangeSubject.asObservable();
  }

  notifyPayorChange(): void {
    this.payorChangeSubject.next(true);
  }
}
